export var FileStatus;

(function (FileStatus) {
  FileStatus["Uploaded"] = "Uploaded";
  FileStatus["Saved"] = "Saved";
})(FileStatus || (FileStatus = {}));